<!-- 新增服务商奖励设置 -->
<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix" style="margin: 0;!important">
        <div class="fl">
          <i class="el-icon-info" />
          {{ dataId ? '查看' : '新增' }}奖励设置
        </div>
        <div class="fr">
          <!--          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置-->
          <!--          </el-button>-->
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->

        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <!-- <b>主信息</b> -->
            </div>

            <div class="iname">
              <div> <em class="f-red">*</em>
                <span>名称:</span>
                <el-input style="width: 56vw" type="text" autocomplete="off" clearable v-model="formData.rewardName">
                </el-input>
              </div>

            </div>

            <div class="iname" style="margin-top:10px">

              <div> <em class="f-red">*</em>
                <span>奖励:</span>
                <el-input style="width: 10vw;" type="text" autocomplete="off" clearable v-model="formData.amount">
                </el-input>
              </div>

              <div class="iname">
                <em class="f-red">*</em>
                <span>有效时间:</span>
                <el-date-picker v-model="formData.date" type="daterange" range-separator="至" start-placeholder="开始日期"
                                value-format="yyyy-MM-dd"
                                style="width:20vw" end-placeholder="结束日期">
                </el-date-picker>
              </div>
              <div class="iname">
                <em class="f-red">*</em>
                <span>是否生效:</span>
                <el-select v-model="formData.stat">
                  <el-option label="生效" :value="1"/>
                  <el-option label="失效" :value="0"/>
                </el-select>
              </div>
            </div>

          </div>

          <div style="display: flex;">
            <div class="d-item">
              <div class="title first">
                <b>服务类型</b>
              </div>

              <div>

                <vxe-table :stripe="true" ref ="serviceTypeTable" row-id="id"
                           :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                           :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                           :checkbox-config="{ checkAll:serviceTypeCheckAll,checkRowKeys: formData.serverTypeIds }"
                           show-overflow height="300" :column-config="{ resizable: true }" resizable
                           :tree-config="{transform: true}"
                           :data="serviceTypeData" @checkbox-change="serviceTypeCheckChange" @checkbox-all ="serviceTypeCheckChange">
                  <vxe-column type="checkbox" width="100" tree-node></vxe-column>
                  <vxe-column field="serviceTypeName" width="120" title="服务类型"></vxe-column>
                </vxe-table>
              </div>
            </div>

            <div  class="d-item" style="margin-right: 10px">
              <!--产品类型-->
              <div class="title first">
                <b> {{$t('common.ProductType')}}</b>
              </div>
              <div>
                <vxe-table
                  class="mytable-scrollbar"
                  :stripe="true"
                  :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                  :row-config="{height: 30,isHover: true,padding: 0,}"
                  :row-style="{ fontSize: '12px',  }"
                  show-overflow
                  height="260" :column-config="{ resizable: true }"
                  resizable
                  row-id="id"
                  ref="itemCategoryTable"
                  :tree-config="{transform: true}"
                  :checkbox-config="{labelField: 'name',checkAll:itemCategoryCheckAll, checkRowKeys: formData.itemCategoryIds}"
                  :data="tableData1"
                  @checkbox-change="selectItems"
                  @checkbox-all="selectItems"
                >
                  <vxe-column type="checkbox" width="80" :tree-node="true"></vxe-column>
                  <vxe-column field="categoryName" width="120" title="产品类型"></vxe-column>
                </vxe-table>
              </div>

            </div>

            <div class="d-item">
              <div class="title first">
                <b>满意度</b>
              </div>
              <div>
                <vxe-table :stripe="true" ref="satisfactionLevelTable" row-id="satisfactionLevel"
                           :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                           :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                           :checkbox-config="{ checkAll:satisfactionLevelcheckAll,checkRowKeys: formData.satisfactionLevels  }"
                           show-overflow height="300" :column-config="{ resizable: true }" resizable
                           :data="satisfactionLevelDatas" @checkbox-change="satisfactionLevelCheckChange" @checkbox-all ="satisfactionLevelCheckChange">
                  <vxe-column type="checkbox" width="55" ></vxe-column>
                  <vxe-column field="satisfactionLevelName" width="120" title="满意度"></vxe-column>
                </vxe-table>

              </div>
            </div>

            <div class="d-item">
              <div class="title first">
                <b>工程师认证等级</b>
              </div>
              <div>
                <vxe-table :stripe="true" ref="starLevelTable" row-id="authLevel"
                           :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                           :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                           :checkbox-config="{ checkAll:authLevelcheckAll,checkRowKeys: formData.authLevels  }"
                           show-overflow height="300" :column-config="{ resizable: true }" resizable
                           :data="authLevelDatas" @checkbox-change="starLevelCheckChange" @checkbox-all ="starLevelCheckChange">
                  <vxe-column type="checkbox" width="55" ></vxe-column>
                  <vxe-column field="authLevelName" width="120" title="工程师认证等级"></vxe-column>
                </vxe-table>

              </div>
            </div>

            <div class="d-item">
              <div class="title first">
                <b>{{$t('common.ServiceArea')}}</b>
              </div>
              <div class="iname2" style="display: flex;">
                <div class="item1">
                  <em class="f-red">*</em>
                  <span style="white-space:nowrap">{{$t('common.ServiceArea')}}:</span>
                </div>
                <el-form-item>
                  <template>
                    <!-- <el-cascader :props="areaProps" v-model="tenant.userProvince" :clearable="true" style="width: 9vw;"
                      @change="handleChange"  collapse-tags  ref="cascaderAddr">
                    </el-cascader> -->
                    <el-input style="width: 9vw;margin-top: 5px;" v-model="formData.userProvince" @focus="showItemPop = true"
                    > </el-input>
                  </template>
                </el-form-item>
                <!-- <el-button type="primary" class="button-sty btn_zdy" @click="addAreaData">
                  <i class="el-icon-plus"></i>
                  添加服务区域
                </el-button> -->
                <el-button style="margin: 5px;" type="primary" class="button-sty btn_zdy" @click="handleDeleteList">
                  <i class="el-icon-delete"></i>
                  {{$t('common.BatchDeletion')}}
                </el-button>
              </div>
              <div class="tab">
                <vxe-table ref="filterTable" :data="areaData" class="table_item pic_item" :stripe="true"
                           :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                           :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                           show-overflow height="260" :column-config="{ resizable: true }" @checkbox-all="areaSelectAll"
                           @checkbox-change="areaSelect">
                  <vxe-column type="checkbox" width="40"></vxe-column>
                  <vxe-column field="areaNamePath"  :title="$t('common.ProvincialAddress')" width="300">
                  </vxe-column>

                  <vxe-column  :title="$t('common.Controls')" width="90">
                    <template slot-scope="scope">
                      <div @click="handleDelete(scope.row.id)">
                        <el-tooltip :enterable="false" effect="dark" content="删除" placement="top"
                                    popper-class="tooltip-skin">
                          <i class="el-icon-delete" style="font-size: 18px; color: #00c4b3"></i>
                        </el-tooltip>
                      </div>
                    </template>
                  </vxe-column>
                </vxe-table>


              </div>
            </div>

          </div>
          <div style="height:10px"></div>
        </div>
      </div>
    </el-form>
    <!-- 地区选择 -->
    <addressDialog :visiable.sync="showItemPop" v-if="showItemPop" @addressList="addressList" />
  </div>
</template>
<script>
import Tinymce from '@/components/Tinymce';
import request from "@/router/axios";
import api from "@/api/projectApi";
import {dictType, loadDictData} from "@/config/dictType";
// 地区选择
import addressDialog from '@/views/dialogCommon/addressDialog.vue';


export default {
  name: 'edit',
  props: {
    _dataId: [String, Number],
    msg: String
  },
  components: {
    Tinymce,
    addressDialog
  },

  data() {
    return {

      pName: [
        { id: 1, name: 'standardBase', title: '标准基数' },
        { id: 2, name: 'startCoefficient', title: '网点星级系数' },
        { id: 3, name: 'areaCoefficient ', title: '区域系数' },
        { id: 4, name: 'satisfactionCoefficient', title: '满意度系数' },
        { id: 5, name: 'bonusFee', title: '红利' },

      ],

      area: {
        temp: {},
        checkedArray: []
      },

      satisfactionLevelDatas:[],
      starLevelDatas:[],
      authLevelDatas:[],
      currentval: '',
      TagsAll: [],
      tableData1: [],
      areaData: [],
      inputLength: '',
      height: '32px',
      label: '测试',
      dataId: '',

      showItemPop: false,
      getDataUrl: '/basic/sfSettleReward/getById',
      addressUrl: '/basic/basArea/getListByIdList',
      getAreaDataUrl: '/basic/basArea/getList',
      getAreaPathDataUrl: '/basic/basArea/getAreaPathList',
      addDataUrl: '/basic/sfSettleReward/save',
      updateDataUrl:'/basic/sfSettleReward/update',
      getServerTypeDataUrl: '/basic/basServiceType/getAllTree',
      buychannelUrl :"/basic/basBuyChannel/getList",
      buyDatas:[],
      siteQualityUrl:"/admin/dict/getItemListByDictType",
      siteQualityData:[],
      serviceTypeData:[],
      regex:/[(,),+,-,/,*]/g,
      serviceTypeCheckAll:false,
      itemCategoryCheckAll:false,
      siteTypeCheckAll:false,
      buyChannelCheckAll:false,
      starLevelcheckAll:false,
      authLevelcheckAll:false,
      satisfactionLevelcheckAll:false,
      checkAll: false,
      isIndeterminate: false,
      activeName: 'first',

      // 基本信息
      formData: {
        stat:1,
        siteTypes:[],
        buyChannelIds:[],
        serverTypeIds:[],
        itemCategoryIds:[],
        authLevels:[],
        satisfactionLevels:[],
        areaIds:[],
        rewardName:null,
        amount:null,
        rewardType:2
      },
      showProductCategoryDialog: false,


    };
  },
  watch: {
    currentval() {
      // 实时改变input输入框宽度，防止输入内容超出input默认宽度显示不全
      this.inputLength = this.$refs.inputTag.value.length * 12 + 50;
    },
    // value () {
    // 	this.$refs.selectRef.visible =false
    // }
  },

  computed: {
    inputStyle() {
      let style = {};
      style.width = `${this.inputLength}px`;
      return style;
    },
    //将生成的数据拼接成字符串 后台需要这种格式的数据。
    // finall(){
    //     return this.TagsAll.join(',')
    // }
  },

  created() {
    if (this._dataId && !isNaN(this._dataId)) {
      this.dataId = this._dataId
      this.getData()
    }else{
      this.init()
    }

  },

  mounted() {


    // this.$refs.selectRef.toggleMenu()
  },

  methods: {

    addressList(data) {
      console.log(data, "穿过i来");

      this.$http({
        url: this.addressUrl,
        method: 'post',
        data: {
          idList: data
        }
      }).then(res => {
        console.log(res, "选择的地区");
        let tempArray = this.areaData
        let idArray = this.formData.areaIds
        res.data.data.forEach(item => {
          tempArray.push({
            id: item.id,
            areaNamePath: item.areaNamePath
          })
          this.formData.areaIds.push(item.id)
        })
        this.areaData = this.uniqueArr(tempArray)
        console.log("1", this.areaData)
        console.log("2", this.formData.areaIds)
        // if(res!==''){
        //   this.areaData.push(res.data.data)
        // }

      })
    },

    // 添加地区列表
    addAreaData() {
      if (this.area.temp.level < 3) {
        this.$message.warning('请至少选择到市级地址')
      } else {
        if (this.area.temp.level === 4 || this.area.temp.level === 3) {
          this.$http({
            url: this.getAreaPathDataUrl,
            method: 'post',
            data: {
              parentId: this.area.temp.id
            }
          }).then(res => {
            let tempArray = this.areaData
            res.data.data.forEach(item => {
              tempArray.push({
                id: item.id,
                areaNamePath: item.areaNamePath
              })
            })
            this.areaData = this.uniqueArr(tempArray)
          })
        } else if (this.area.temp.level === 5) {
          this.$http({
            url: this.getAreaPathDataUrl,
            method: 'post',
            data: {
              areaId: this.area.temp.id,
            }
          }).then(res => {
            let tempArray = this.areaData
            res.data.data.forEach(item => {
              tempArray.push({
                id: item.id,
                areaNamePath: item.areaNamePath
              })
            })
            this.areaData = this.uniqueArr(tempArray)
          })
        }
      }
    },

    // 单个地区删除
    handleDelete(id) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.areaData = this.areaData.filter(item => item.id !== id)
        this.formData.areaIds = this.formData.areaIds.filter(item => item !== id)
      })
    },

    // 批量删除地区
    handleDeleteList() {
      console.log(this.area.checkedArray)
      if (this.area.checkedArray.length === 0) {
        this.$message.warning('请先勾选地址')
      } else {
        this.$baseConfirm('您确定要删除吗？').then(() => {
          this.area.checkedArray.forEach(item => {
            this.areaData = this.areaData.filter(item1 => item1.id !== item.id)
            this.formData.areaIds = this.formData.areaIds.filter(item => item !== id)
          })
          this.area.checkedArray = []
        })
      }
    },

    // 单个地址选中
    areaSelect(data) {
      console.log(data, '选中')
      if (data.checked) {
        this.area.checkedArray.push(data.row)
      } else {
        this.area.checkedArray = this.area.checkedArray.filter(item => item.id !== data.row.id)
      }
    },

    // 地址全选
    areaSelectAll(selection) {
      this.area.checkedArray = []
      let records = selection.records
      records.forEach(item => {
        this.area.checkedArray.push(item)
      })
    },

    // 去重
    uniqueArr(arr) {
      let result = [];
      arr.forEach((item) => {
        if (!result.some(m => m.id === item.id)) {
          result.push(item);
        }
      });
      return result;
    },

    //分割字符
    init(){
      this.loadBuyDatas()
      this.loadServerTypeTableData()
      this.loadItemCategoryTableData()
      this.loadSiteQualityData()
      this.satisfactionLevelDatas=[{satisfactionLevel:1,satisfactionLevelName:'非常满意'},{satisfactionLevel:2,satisfactionLevelName:'满意'},{satisfactionLevel:3,satisfactionLevelName:'一般'},{satisfactionLevel:4,satisfactionLevelName:'不满意'},{satisfactionLevel:5,satisfactionLevelName:'非常不满意'},]
      this.authLevelDatas=[{authLevel:1,authLevelName:'待认证'},{authLevel:3,authLevelName:'初级'},{authLevel:5,authLevelName:'中级'},{authLevel:7,authLevelName:'高级'},{authLevel:9,authLevelName:'资深级'},]
    },
    pt(event) {
      this.TagsAll.push(event)
      console.log(this.TagsAll,"this.TagsAll表达式里的值");
    },
    removeTag(index) {
      this.TagsAll.splice(index, 1)
    },
    spanMouseDown(e) {
      e.preventDefault()
    },
    //回车-- 增加tag
    addTags() {
      this.$refs.fatherBox.style.borderColor = '#dcdee2'
      this.$refs.boxShadow = '0'
      this.height = '32px'
      this.validInput()

    },
    // 增加校验规则
    validInput() {
      if (this.currentval) {
        if (this.limit && this.TagsAll.length === this.limit) {
          this.$Message.info(`最多可输入${this.limit}个标签`)
          return
        }
        this.TagsAll.push(this.currentval);
        this.currentval = '';
      }
    },
    //键盘删除键删除tag
    deleteTags() {
      if (this.currentval) return
      this.TagsAll.pop()
    },
    onclick() {
      this.validInput()
      this.$nextTick(() => {
        this.$refs.inputTag.focus();
        this.$refs.fatherBox.style.borderColor = '#57a3f3'
        this.$refs.fatherBox.style.outline = 0
        this.$refs.boxShadow = '0 0 0 2px #57a3f3 0.2'
        this.height = 'auto'
      })
    },

    loadBuyDatas(){
      this.$http({
        url: this.buychannelUrl,
        method: 'post',
        data: {}
      }).then(res => {
        this.buyDatas = res.data.data
      })
    },
    buyChannelCheckChange(){
      if (this.$refs.buyChannelTable.isAllCheckboxChecked()){
        this.formData.buyChannelIds.push(0);
        this.formData.isAllBuyChannel = 1;
      }else{
        this.formData.isAllBuyChannel = 0;
        const tableData = this.$refs.buyChannelTable.getCheckboxRecords();
        var buyChannelId = [];
        for (let i = 0; i < tableData.length; i++) {
          buyChannelId.push(tableData[i].id)
        }
        this.formData.buyChannelIds = buyChannelId;
      }
    },
    starLevelCheckChange(){
      if (this.$refs.starLevelTable.isAllCheckboxChecked()){
        this.formData.authLevels.push(0);
        this.formData.isAllAuthLevel = 1;
      }else{
        this.formData.isAllAuthLevel = 0;
        const tableData = this.$refs.starLevelTable.getCheckboxRecords();
        var authLevels = [];
        console.log(1,tableData)
        for (let i = 0; i < tableData.length; i++) {
          authLevels.push(tableData[i].authLevel)
        }
        this.formData.authLevels = authLevels;
      }
    },

    satisfactionLevelCheckChange(){
      if (this.$refs.satisfactionLevelTable.isAllCheckboxChecked()){
        this.formData.satisfactionLevels.push(0);
        this.formData.isAllsatisfactionLevel = 1;
      }else{
        this.formData.isAllsatisfactionLevel = 0;
        const tableData = this.$refs.satisfactionLevelTable.getCheckboxRecords();
        var starLevel = [];
        for (let i = 0; i < tableData.length; i++) {
          starLevel.push(tableData[i].satisfactionLevel)
        }
        this.formData.satisfactionLevels = starLevel;
      }
    },
    loadSiteQualityData(){
      // this.$http({
      //   url: this.siteQualityUrl,
      //   method: 'post',
      //   data: {dictType:'site_quality'}
      // }).then(res => {
      //   this.siteQualityData = res.data.data
      // })
      loadDictData(dictType.siteQuality).then(res => {
        this.siteQualityData =res.data.data
        // res.data.data.forEach(item => {
        //   this.siteQualityData.push({
        //     label: item.label,
        //     value: item.id
        //   })
        // })
      })
    },
    siteQualityCheckChange(){
      if (this.$refs.siteQualityTable.isAllCheckboxChecked()){
        this.formData.siteTypes.push(0);
        this.formData.isAllSiteType = 1;
      }else{
        this.formData.isAllSiteType = 0;
        const tableData = this.$refs.siteQualityTable.getCheckboxRecords();
        const siteType = [];
        for (let i = 0; i < tableData.length; i++) {
          siteType.push(tableData[i].id)
        }
        this.formData.siteTypes = siteType;
      }
    },
    serviceTypeCheckChange({ row }){
      if (this.$refs.serviceTypeTable.isAllCheckboxChecked()){
        this.formData.serverTypeIds.push(0);
        this.formData.isAllServerTypes = 1;
      }else{
        this.formData.isAllServerTypes = 0;
        const tableData = this.$refs.serviceTypeTable.getCheckboxRecords();
        const serveTypeId = [];
        for (let i = 0; i < tableData.length; i++) {
          //存在下级节点
          serveTypeId.push(tableData[i].id)
          // if(tableData[i].hasChild){
          //   this.$http({
          //     url: this.getServerTypeDataUrl,
          //     method: 'post',
          //     data: {
          //       parentId: tableData[i].id
          //     }
          //   }).then(res => {
          //     const childs = res.data.data;
          //     for (let j = 0; j < childs.length; j++) {
          //       serveTypeId.push(childs[j].id)
          //     }
          //   })
          // }else{
          //   //判断list是否存在父节点id
          //   if(tableData[i].parentId){
          //       if(serveTypeId.indexOf(tableData[i].parentId)==-1){
          //         serveTypeId.push(tableData[i].parentId);
          //       }
          //   }
          // }
        }
        this.formData.serverTypeIds = serveTypeId;
      }
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: this.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data || {}
          let tempList = []
          tempList.push(data.beginDate)
          tempList.push(data.endDate)
          data.date = tempList
          this.formData = data


          if (data.serverTypeIds){
            if (data.isAllServerTypes && Number(data.isAllServerTypes)==1){
              this.serviceTypeCheckAll = true;
            }else{
              const  showServerTypeIds =[];
              data.serverTypeIds.forEach(item => {
                showServerTypeIds.push(item)
              })
              this.formData.serverTypeIds = showServerTypeIds;
            }
            // this.$refs.serviceTypeTable.reloadData(this.serviceTypeData);
          }

          if (data.itemCategoryIds){
            if (data.isAllItemCategorys && Number(data.isAllItemCategorys)==1){
              this.itemCategoryCheckAll = true;
              console.log(1)
            }else{
              const  itemCategoryIds =[];
              data.itemCategoryIds.forEach(item => {
                itemCategoryIds.push(item)
              })
              this.formData.itemCategoryIds = itemCategoryIds;

            }
            // this.$refs.serviceTypeTable.reloadData(this.serviceTypeData);
          }

          if (data.satisfactionLevels){
            if (data.isAllSatisfactionLevel && Number(data.isAllSatisfactionLevel)==1){
              this.satisfactionLevelcheckAll = true;
            }else{
              const  satisfactionLevelIds =[];
              data.satisfactionLevels.forEach(item => {
                satisfactionLevelIds.push(item)
              })
              this.formData.satisfactionLevelIds = satisfactionLevelIds;
            }
            // this.$refs.serviceTypeTable.reloadData(this.serviceTypeData);
          }

          if (data.starLevels){
            if (data.isAllStarLevel && Number(data.isAllStarLevel)==1){
              this.starLevelcheckAll = true;
            }else{
              const  showStarLevels =[];
              data.starLevels.forEach(item => {
                showStarLevels.push(item)
              })
              this.formData.starLevels = showStarLevels;
            }
            // this.$refs.starLevelTable.reloadData(this.starLevelDatas);
          }
          if (data.authLevels){
            if (data.isAllAuthLevel && Number(data.isAllAuthLevel)==1){
              this.authLevelcheckAll = true;
            }else{
              const  showAuthLevels =[];
              data.authLevels.forEach(item => {
                showAuthLevels.push(item)
              })
              this.formData.authLevels = showAuthLevels;
            }
            // this.$refs.starLevelTable.reloadData(this.starLevelDatas);
          }
          if (data.areaList){
            this.areaData = data.areaList
          }
          if(this.formData.reward){
            this.getTags(this.formData.reward);
          }
          this.init();
        })
      }
    },
    getTags(str){
      let index = str.search(this.regex)==0?1:str.search(this.regex)>0?str.search(this.regex):str.length;
      const strs = str.substring(0,index);
      this.TagsAll.push(strs)
      if (str.length>strs.length){
        this.getTags(str.substring(index,str.length));
      }

    },
    closeOptions() {
      this.$refs.selectRef.visible = true//通过ref直接绑定对应的selection调用blur方法即可隐藏下拉框
    },




    /***************************              服务类型                 **************************/
    // 一级服务类型加载
    loadServerTypeTableData() {
      this.$http({
        url: this.getServerTypeDataUrl,
        method: 'post',
        data: {}
      }).then(res => {
        this.serviceTypeData = res.data.data
      })
    },

    /***************************              服务类型                 **************************/


    /***************************               产品分类                 **************************/
    // 一级产品分类加载
    loadItemCategoryTableData() {
      this.$http({
        url: '/basic/basItemCategory/getAllTree',
        method: 'post',
        data: {
          categoryType: 1,
          usable: 1
        }
      }).then(res => {
        this.tableData1 = res.data.data
      })
    },


    // 服务品类复选框
    selectItems({records}) {
      // 拿到所有id
      // let temp = records.map(item => item.id)
      //
      // // 获取有子类的父id
      // let parentTemp = new Set()
      // records.forEach(item => {
      //   if (item.parentId != 0) {
      //     parentTemp.add(item.parentId)
      //   }
      // })
      //
      // // 去除有子类的父id
      // let temp1 = []
      // temp.forEach(item => {
      //   if (!parentTemp.has(item)) {
      //     temp1.push(item)
      //   }
      // })
      // this.selectedItemCategoryIdList = temp1
      // console.log('选中的服务品类id', temp1)
      if (this.$refs.itemCategoryTable.isAllCheckboxChecked()){
        this.formData.itemCategoryIds.push(0);
        this.formData.isAllItemCategory = 1;
      }else{
        this.formData.isAllItemCategory = 0;
        const tableData = this.$refs.itemCategoryTable.getCheckboxRecords();
        var itemCategoryId = [];
        for (let i = 0; i < tableData.length; i++) {
          itemCategoryId.push(tableData[i].id)
        }
        this.formData.itemCategoryIds = itemCategoryId;
      }

    },

    /***************************               产品分类                 **************************/



    saveData() {

      if (this.formData.rewardName === null || this.formData.rewardName === '' || this.formData.rewardName === undefined) {
        this.$message.error('请输入名称！')
        return
      }
      if (this.formData.amount === null || this.formData.amount === '' || this.formData.amount === undefined) {
        this.$message.error('请输入奖励！')
        return
      }
      let date = this.formData.date;
      if (date != null && date.length > 0) {
        this.formData.beginDate = date[0]
        this.formData.endDate = date[1]
      }else{
        this.$message.error('请输入对应的有效时间！')
        return
      }
      if (this.formData.serverTypeIds.length === 0) {
        this.$message.error('请选择服务类型！')
        return
      }
      if (this.formData.itemCategoryIds.length === 0) {
        this.$message.error('请选择产品类型！')
        return
      }
      if (this.formData.satisfactionLevels.length === 0) {
        this.$message.error('请选择满意度！')
        return
      }
      if (this.formData.authLevels.length === 0) {
        this.$message.error('请选择工程师认证等级！')
        return
      }
      if (this.areaData.length === 0) {
        this.$message.error('请选择服务区域！')
        return
      }

      this.$baseConfirm('您确定要保存吗？').then(() => {
        this.$mask.open()

        this.$http({
          url: this.isEdit ? this.updateDataUrl : this.addDataUrl,
          method: `post`,
          data: this.formData
        }).then(res => {
          this.$message({
            type: res.data.type,
            message: res.data.content
          });
          this.$emit('editViewDataUpdate')
          this.$mask.close()

          // this.reload()
        }).catch(e => {
          console.error(e)
          this.$message.error("保存失败！");
          this.$mask.close()

        })
      })

    },

  },
};

</script>
<style lang="scss" scoped>
.PN {
  margin-left: 110px;
  border: 1px solid #ededed;
  width: 36vw;
  padding: 0 15px;
  margin-top: 5px;
  font-size: 12px;

  p {
    display: flex;
    justify-content: space-between;
  }

}

.prop-box {
  display: flex;
  justify-content: center;

}

::v-deep .vxe-table--render-default .vxe-body--column:not(.col--ellipsis),
.vxe-table--render-default .vxe-footer--column:not(.col--ellipsis),
.vxe-table--render-default .vxe-header--column:not(.col--ellipsis) {
  padding: 8px 0 !important;
}

::v-deep .vxe-table--render-default .vxe-body--column:not(.col--ellipsis),
.vxe-table--render-default .vxe-footer--column:not(.col--ellipsis),
.vxe-table--render-default .vxe-header--column:not(.col--ellipsis) {
  padding: 8px 0 !important;
}

::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #00c4b3 !important;
  border-color: #00c4b3 !important;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #00c4b3;
  border-color: #00c4b3;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #00c4b3 !important;
}


.tab {
  margin-left: 20px;
}

.table_main {
  width: 28%;
}

.btn_zdy {
  margin: 5px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .vxe-grid .vxe-button.type--button.is--circle {
  display: none;
}

::v-deep .vxe-grid .vxe-table {
  /* overflow: hidden; */
  border: 1px solid #ededed;
  margin-right: 10px;
}

.iname {
  margin-left: 35px;
  display: flex;
  align-items: center;
  flex-direction: row;

  span {
    font-weight: 400;
    text-align: right;
    // width: 112px;
    position: relative;
    font-size: 12px;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.iname2 {
  margin: 0px 15px;


  .item1 {
    line-height: 36px;

    span {
      font-weight: 400;
      text-align: right;
      // width: 112px;
      position: relative;
      font-size: 12px;
      padding: 0 10px 0 4px;
      color: rgba(86, 86, 86, 0.96);
    }
  }

}

.title1 {
  font-weight: 400;
  text-align: right;
  width: 81px;
  position: relative;
  font-size: 12px;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);

}

.brand {
  margin: 20px 0 0px 20px;
  display: flex;

  .brand_item2 {
    margin-left: 20px;
  }

}

#containt .table-detail tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}

.expand-wrapper {
  padding: 10px;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {

  position: absolute !important;
  bottom: -35px !important;

}

#containt .detail-wrap .d-cont {
  overflow: auto !important;
}

#containt .detail-wrap .d-cont .d-item:last-child {
  margin-bottom: 0px;
}

::v-deep .el-select__tags>span {
  display: flex !important;
;
}

::v-deep .el-tag.el-tag--info .el-tag__close {
  display: none;
}

::v-deep .el-range-editor--medium.el-input__inner {
  height: 28px !important;
}

::v-deep .el-range-editor--medium .el-range__icon {
  line-height: 22px !important;
}

.grad_father_box {
  width: 75vw;
  position: relative;
  min-height: 32px;
}

/* 外层div */
.father_box {
  /* width: 300px; */
  box-sizing: border-box;
  background-color: white;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  font-size: 12px;
  text-align: left;
  padding-left: 5px;
  word-wrap: break-word;
  overflow: hidden;
  border-radius: 5px;
  position: absolute;
  width: 100%;
}

.father_box:focus {
  border-color: #57a3f3;
  /* outline: 0; */
  box-shadow: 0 0 0 2px #57a3f3 0.2;
}

/* 标签 */
.spanbox {
  margin-right: 5px;
  cursor: pointer;
  display: inline-table;
  background: #e3f2fd;
  padding: 2px 0;
  border: 1px solid transparent;
  border-radius: 2px;
  color: #039be5;
  font-size: 12px;
  vertical-align: top;
  padding: 3px;
  margin-bottom: 4px;
  margin-top: 5px;
}

.tagspan {
  padding-right: 5px;
}

.span_close {
  padding-left: 3px;
  border-left: 2px solid #fff;
}

.span_close:hover {
  color: red;
}

/* input */
.inputTag {
  font-size: 12px;
  border: none;
  box-shadow: none;
  outline: none;
  background-color: transparent;
  padding: 0;
  width: auto;
  width: 100px;
  vertical-align: top;
  height: 30px;
  color: #495060;
  line-height: 30px;
  display: inline-block;
}
</style>
